import {
  WSElement,
  WSList,
  WSLoader,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../../query/hooks/helpers";
import { ExtendedRequirementPreviewList } from "../../../Requirements/components/ExtendedRequirementPreviewList";
import { ExtendedRequirementsTable } from "../../../Requirements/components/ExtendedRequirementsTable";
import {
  ExtendedRequirementTableItemData,
  RequirementAdditionalData,
  RequirementContextType,
  RequirementTableItemData
} from "../../../Requirements/types";

export type RouteClientsRequirementsProps = {
  requirements: ExtendedRequirementTableItemData[];
  isLoading: boolean;
};

export const RouteClientsRequirements: React.FC<
  RouteClientsRequirementsProps
> = ({ requirements, isLoading }) => {
  const history = useHistory();
  const userId = useUserId();

  const completedLength = useMemo(() => {
    return requirements.filter(e => e.status === RequirementStatus.Complete)
      .length;
  }, [requirements]);

  const isRequirementsComplete = useMemo(() => {
    return requirements.every(e => e.status === RequirementStatus.Complete);
  }, [requirements]);

  const [showPreviews, setShowPreviews] = useState(false);

  const getOnViewDetails = (
    requirement: RequirementTableItemData,
    dataSource: RequirementAdditionalData
  ) => {
    return "requirementId" in requirement
      ? (requirement: IRequirementResponse) =>
          history.push(
            `/member/payers/${requirement.payerId}/requirement/${requirement.requirementId}`
          )
      : undefined;
  };

  return (
    <WSElement>
      <WSList gap="L">
        <WSSectionToolbar
          title="Requirements"
          pill={
            isLoading
              ? undefined
              : {
                  icon: true,
                  text: `${completedLength} of ${requirements.length} completed`,
                  theme: isRequirementsComplete ? "success" : "warning"
                }
          }
          buttons={[
            {
              label: "",
              onClick: () => setShowPreviews(true),
              kind: showPreviews ? "Secondary" : "Link",
              icon: "grid",
              onlyIcon: true,
              size: "S"
            },
            {
              label: "",
              onClick: () => setShowPreviews(false),
              kind: !showPreviews ? "Secondary" : "Link",
              icon: "list",
              onlyIcon: true,
              size: "S"
            }
          ]}
        />
        {isLoading ? (
          <WSLoader.Spinner size="M" />
        ) : showPreviews ? (
          <ExtendedRequirementPreviewList
            requirements={requirements}
            contextType={RequirementContextType.Payer}
            getOnViewDetails={getOnViewDetails}
            hideTaxVerificationConsent
          />
        ) : (
          <ExtendedRequirementsTable
            requirements={requirements}
            contextType={RequirementContextType.Payer}
            showOverrideActions
            hideTaxVerificationConsent
            hideActions={false}
            getOnViewDetails={getOnViewDetails}
          />
        )}
      </WSList>
    </WSElement>
  );
};
